// Note: the __VAR__ values are updated by gitlab during CI
// execution.
//
export const appinfo = {
  name: "markadoc",
  production: true,
  version: "0.0.0-dev-78461a82",
  build_id: "3427",
  build_nbr: "2109",
  build_commit: "78461a82", // <-- Added
  build_date: "2026-11-05T04:06:39Z",
  localApiUrl: "http://localhost:3000/",
  localMailApiUrl: "http://localhost:4000/v1/mail",
  devApiUrl: "https://api.dev.redlinespro.mdcgit.com/",
  devMailApiUrl: "http://localhost:4000/v1/mail",
  dfltApiUrl: "__APIURL__",
  apiUrl: "https://api.redlinespro.mdcgit.com/",
  mailApiUrl: "__MAIL_APIURL__",
};

// maybe add build variable set by gitlab build pipeline to the above when
// we get more dev going for traceability. Or maybe commit tags.

// Note: dont read name and version from package.json as it is a vulnerabiity.
